var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 20,
    role: "img",
    "aria-label": "git",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "git") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 43,
    height: 20,
    fill: "#f05033"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkdpdDwvdGl0bGU+PHBhdGggZD0iTTIzLjU0NiAxMC45M0wxMy4wNjcuNDUyYy0uNjA0LS42MDMtMS41ODItLjYwMy0yLjE4OCAwTDguNzA4IDIuNjI3bDIuNzYgMi43NmMuNjQ1LS4yMTUgMS4zNzktLjA3IDEuODg5LjQ0MS41MTYuNTE1LjY1OCAxLjI1OC40MzggMS45bDIuNjU4IDIuNjZjLjY0NS0uMjIzIDEuMzg3LS4wNzggMS45LjQzNS43MjEuNzIuNzIxIDEuODg0IDAgMi42MDQtLjcxOS43MTktMS44ODEuNzE5LTIuNiAwLS41MzktLjU0MS0uNjc0LTEuMzM3LS40MDQtMS45OTZMMTIuODYgOC45NTV2Ni41MjVjLjE3Ni4wODYuMzQyLjIwMy40ODguMzQ4LjcxMy43MjEuNzEzIDEuODgzIDAgMi42LS43MTkuNzIxLTEuODg5LjcyMS0yLjYwOSAwLS43MTktLjcxOS0uNzE5LTEuODc5IDAtMi41OTguMTgyLS4xOC4zODctLjMxNi42MDUtLjQwNlY4LjgzNWMtLjIxNy0uMDkxLS40MjQtLjIyMi0uNi0uNDAxLS41NDUtLjU0NS0uNjc2LTEuMzQyLS4zOTYtMi4wMDlMNy42MzYgMy43LjQ1IDEwLjg4MWMtLjYuNjA1LS42IDEuNTg0IDAgMi4xODlsMTAuNDggMTAuNDc3Yy42MDQuNjA0IDEuNTgyLjYwNCAyLjE4NiAwbDEwLjQzLTEwLjQzYy42MDUtLjYwMy42MDUtMS41ODIgMC0yLjE4NyIvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 305,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 150
  }, "git"), /*#__PURE__*/React.createElement("text", {
    x: 305,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 150
  }, "git"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.10a54647e4796ac0fa2e24171fe4394e.svg";
export { ForwardRef as ReactComponent };